import type { ZodType } from 'zod';

export default async function fetchAndParse<T>(model: ZodType<T, any, any>, fetch: () => Promise<unknown>) {
  const res = await fetch();
  return model.parse(res);
}
